import { z } from 'zod'

export const assignmentListRouteSearchSchema = {
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).optional(),
  q: z.string().optional(),
  status: z.string().optional(),
  buyer_group_id: z.string().optional(),
}
